import { Component, OnInit } from "@angular/core";

import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { NavBarComponent } from "../../../shared/nav-bar/nav-bar.component";
import { FooterBannerComponent } from "../footer-banner/footer-banner.component";
import { environment } from "../../../environments/environment";
import { SessionService } from "../../../Utils/_services/session/session.service";

@Component({
  selector: "app-pricing",
  standalone: true,
  imports: [NavBarComponent, FooterBannerComponent, RouterLink],
  templateUrl: "./pricing.component.html",
  styleUrl: "./pricing.component.css",
})
export class PricingComponent implements OnInit {
  pwaUrl: string = `${environment.pwaFrontendBaseUrl}/auth/signup`;
  pwaSubscriptionUrl: string = `${environment.pwaFrontendBaseUrl}/settings/subscription`;
  isLoggedIn: boolean = false;

  plans = [
    {
      name: "Premium",
      price: "$9.99",
      period: "/month",
      popular: true,
      badge: "Popular",
      features: [
        "100 daily swipes",
        "20 likes",
        "3 Pops",
        "2 Active lobbies (Create)"
      ]
    },
    {
      name: "VIP",
      price: "$19.99",
      period: "/month",
      popular: false,
      badge: "Best Value",
      features: [
        "250 daily swipes",
        "50 likes",
        "6 Pops",
        "3 Active lobbies (Create)"
      ]
    }
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private sessionService: SessionService
  ) {}

  ngOnInit(): void {
    this.isLoggedIn = this.sessionService.isAuthenticated();
  }

  selectPlan(plan: any): void {
    if (this.isLoggedIn) {
      window.location.href = this.pwaSubscriptionUrl;
    } else {
      window.location.href = this.pwaUrl;
    }
  }
}
